import { GAME_ID, REDUX_ACTIONS } from '../../../data/constants';

export const initialState = {
  isZoomed: false,
  isZoomoutBeingBlocked: false,
};

const singleImageSceneReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_SINGLE_IMAGE_ZOOM:
      return {
        ...state,
        isZoomed: payload,
      };

    case REDUX_ACTIONS.SET_BLOCKING_SINGLE_IMAGE_ZOOMOUT:
      return {
        ...state,
        isZoomoutBeingBlocked: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default singleImageSceneReducer;
